import { HandlerEvent } from 'post-robot';
import { saveMeta } from 'communicator/store';
import { getAccessToken, getApiKey, getMeta } from 'communicator/store/selectors';
import fetchDeleteIntent from 'communicator/utils/api/delete-intent';
import { markEnd, markStart } from 'communicator/utils/instrumentation';

export default async function deleteIntent(
  event: HandlerEvent<{ suppressDeleteIntentApi: boolean }>
): Promise<void> {
  markStart('delete_intent');
  const intentIdToDelete = getMeta().vIntentId;

  saveMeta({ vIntentId: undefined });

  const accessToken = getAccessToken()?.token;

  // suppressDeleteIntentApi is passed when DCF has already performed DELETE /intent
  if (!accessToken || !intentIdToDelete || event.data.suppressDeleteIntentApi) {
    return;
  }

  await fetchDeleteIntent({
    accessToken,
    apikey: getApiKey(),
    vIntentId: intentIdToDelete
  });

  markEnd('delete_intent');
}
